import { MultiselectDropdownComponent } from "./../multiselect-dropdown/multiselect-dropdown.component";
import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";

import { FormsModule } from '@angular/forms';
import { TranslateModule } from "@ngx-translate/core";
import { ActivityLogTableComponent } from "./activity-log-table/activity-log-table.component";
import { CapitalizePipe } from "app/pipes/pipes";
import {
  ActivityLogFilters,
  ActivityLogFilterOptions,
} from "app/models/activity-log.model";
import moment from "moment-timezone";
import { ActivityLogService } from "app/services/activity-log.service";
import { MatFormFieldModule } from "@angular/material/form-field";
import { DatePipe } from '@angular/common';
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { Inject } from "@angular/core";
import { DateAdapter, MAT_DATE_LOCALE, MatNativeDateModule } from "@angular/material/core";
import { HelperService, UiLang } from "app/services/helper.service";
import { DownloadLogComponent } from "./download-log/download-log.component";

@Component({
    selector: "app-activity-log",
    imports: [
    TranslateModule,
    ActivityLogTableComponent,
    CapitalizePipe,
    MultiselectDropdownComponent,
    TranslateModule,
    FormsModule,
    DatePipe,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    DownloadLogComponent
],
    providers: [ActivityLogService],
    templateUrl: "./activity-log.component.html",
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: ["./activity-log.component.css"]
})

export class ActivityLogComponent implements OnInit {
  constructor(
    public activityLogService: ActivityLogService,
    private helper: HelperService,
    private dateAdapter: DateAdapter<any>,
    @Inject(MAT_DATE_LOCALE) public locale: string
  ) { }

  user: any;

  currentDate: Date = new Date();
  filterStartTime: string = "00:00";
  filterStartDay: Date = moment().subtract(1, "d").toDate();
  filterEndTime: string = "23:59";
  filterEndDay: Date = new Date();
  options = new ActivityLogFilterOptions();

  updateFilters(): void {
    this.activityLogService.updateFilters(this.activityLogService.filters);
  }

  clearFilters(): void {
    this.activityLogService.updateFilters(new ActivityLogFilters());
    this.filterStartTime = "00:00";
    this.filterStartDay = moment().subtract(1, "d").toDate();
    this.filterEndTime = "23:59";
    this.filterEndDay = new Date();
  }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.user.language = localStorage.getItem("language");
    this.helper.setDateAdapterLocale(this.user.language as UiLang, this.dateAdapter);
    this.activityLogService.getUserFilters(this.options);
    this.activityLogService.getCameraGroupFilters(this.options);

    this.activityLogService.filters.startDate = this.combineDateAndTime(
      moment(this.filterStartDay).format('YYYY-MM-DD'),
      this.filterStartTime);
    this.activityLogService.filters.endDate = this.combineDateAndTime(
      moment(this.filterEndDay).format('YYYY-MM-DD'),
      this.filterEndTime);
  }

  updateStartDateTime(): void {
    this.activityLogService.filters.startDate = this.combineDateAndTime(
      moment(this.filterStartDay).format('YYYY-MM-DD'),
      this.filterStartTime);
    this.updateFilters();
  }

  updateEndDateTime(): void {
    this.activityLogService.filters.endDate = this.combineDateAndTime(
      moment(this.filterEndDay).format('YYYY-MM-DD'),
      this.filterEndTime);
    this.updateFilters();
  }

  combineDateAndTime(date: string, time: string): string {
    return `${date} ${time}`;
  }

  onSearchInput(value: string): void {
    this.activityLogService.filters.search = value;
    if (value === '') {
      this.updateFilters();
    }
  }
}
